<template>
	<div>
		<div class="content-header">
			<div class="content-header-inner">
				<h1 class="content-header-title">Reports</h1>
				<div class="project-dropdown-wrap">
					<div v-if="hasProjects"><span class="large-button mini no-margin" @click="addNew">Create New Report</span></div>
					<Icon type="images" class="file-manager-icon" titleFancy="Image Manager" titleFancyPosition="left" @clicked="showImageManager=true" />
				</div>
			</div>
		</div>

		<section class="outer-pad">
			<Table
				class="investigate-table"
				:headings="tableHeadings"
				:items="table.items"
				:pages="table.pages"
				:page="table.page"
				:count="table.count"
				:loading="table.loading"
				:sorted="table.sorted"
				:searchSetup="searchSetup"
				name="reports"
				@pagination="pagination"
				@sort="sort"
				@search="search"
				@selected="selected"
				@checkbox="checkbox"
				@selectReport="selectReport"
				@deleteReport="deleteReport"
				@cloneReport="cloneReport"
				@addNew="addNew"
				:addNewButtonLabel="hasProjects?'Create New Report':''"
				:loadingText="loadingText"
				:emptyLabel="emptyLabel"
				:emptySearch="emptySearch"
				:hideHeadingShowHide="true"
			/>
		</section>

		<div v-if="showCreateReportModal" class="modal has-modal-actions">
			<div class="modal-wrap">
				<div class="modal-inner">
					<h2 class="modal-title">{{modalTitle}} <span class="close" @click="showCreateReportModal = false">X</span></h2>

					<div class="modal-inner-scroll">
						<form>
							<div>
								<FormInput
									type="text"
									v-model="reportName"
									:noMarginBottom="true"
									name="name"
									label="Report Name"
									:required="true"
								/>
							</div>
							<div v-if="allProjects.rankTracking.length">
								<label class="input-label">Default Rank Tracking Project</label>
								<v-select
									v-model="reportProject"
									:options="allProjects.rankTracking"
									:reduce="(option) => option.value"
									label="label"
									:append-to-body="true"
								/>
								<p class="project-input-description">You can override the project for individual report components.</p>
							</div>
							<div v-if="allProjects.dataDive.length">
								<label class="input-label">Default Data Dive Domain</label>
								<v-select
									v-model="reportProjectDataDive"
									:options="allProjects.dataDive"
									:reduce="(option) => option.value"
									label="label"
									:append-to-body="true"
								/>
								<p class="project-input-description">You can override the domain for individual report components.</p>
							</div>
						</form>
					</div>
					<div class="modal-actions">
						<span class="large-button mini" @click="createReport" v-html="modalButtonLabel" />
					</div>
				</div>
			</div>
		</div>

		<ImageManager 
			v-if="showImageManager" 
			@close="showImageManager = false"
		/>
		
	</div>
</template>

<script>
	import Vue from "vue";
	import ApiService from "./../services/api.service";
	import { mapMutations, mapState, mapActions } from "vuex";
	import { TokenService } from "./../services/storage.service";
	import Table from "./../components/Table.vue";
	import TableButton from "./../components/Display/TableButton.vue";
	import Icon from "../components/Display/Icon.vue"
	import ImageManager from "../components/ImageManager.vue"
	import FormInput from "../components/Form/Input.vue";
	export default {
		name: "Reports",
		components: {
			Table,
			Icon,
			ImageManager,
			FormInput
		},
		data() {
			return {
				showImageManager: false,
				showCreateReportModal: false,
				table: {
					page: 1,
					sorted: { nameLowercase: 1 },
					search: {},
					loading: true,
					items: [],
				},
				projects: {
					fetched: false,
					project: null,
					list: [],
				},
				cloning: null,
				reportName: '',
				reportProject: null,
				reportProjectDataDive: null,
				projectIdIsDataDive: false,
				modalTitle: 'Create Report',
				modalButtonLabel: 'Create Report',
			};
		},
		methods: {
			...mapMutations("general", ["updateLoadingText"]),
			...mapActions("general", ["loadProjects"]),
			openImageManager() {
				this.showImageManager = true;
			},
			handleImagesUpdate(images) {
				console.log('Updated images:', images)
			},
			addNew() {
				this.showCreateReportModal = true;
			},
			async cloneReport(info) {
				this.cloning = info._id;
				this.reportName = 'Clone of '+info.name;
				this.reportProject = info.projectId;
				this.reportProjectDataDive = info.projectIdDataDive;
				this.projectIdIsDataDive = !!info.projectIdIsDataDive;
				this.modalButtonLabel = 'Clone Report';
				this.modalTitle = 'Clone ' + info.name;
				this.addNew();
			},
			async createReport() {
				const projectId = this.reportProject || this.reportProjectDataDive || null;
				if ( this.reportName && projectId ) {
					this.projectIdIsDataDive = !!this.reportProjectDataDive && projectId !== this.reportProject;
					this.updateLoadingText('One moment...');
					let vars = { 
						name: this.reportName, 
						projectIdIsDataDive: this.projectIdIsDataDive 
					};
					if ( !this.projectIdIsDataDive && !!this.reportProjectDataDive ) {
						vars.projectId2 = this.reportProjectDataDive;
					}
					if ( this.cloning ) {
						vars.clone = this.cloning;
					}
					const response = await ApiService.post(`reports/${projectId}`, vars);
					this.cloning = null;
					this.reportName = '';
					this.reportProject = null;
					this.reportProjectDataDive = null;
					this.modalTitle = 'Create Report';
					this.modalButtonLabel = 'Create Report';
					this.updateLoadingText();
					this.$router.push(`/reports/${projectId}/${response.data._id}`);
				}
				else {
					this.$snotify.error('Please enter a report name and default project');
				}
			},
			async getReports() {
				try {
					this.table.loading = true;
					const { data } = await ApiService.get(`reports${this.queryString}`);
					Vue.set(this, 'table', {
						...data,
						search: this.table.search,
						loading: false
					});

					this.updateLoadingText();
				} catch (err) {
					console.error('Failed to fetch reports:', err);
					this.$snotify.error('Failed to load reports');
				}
			},
			checkbox() {},
			selected() {},
			sort(info) {
				Vue.set(this.table, "sorted", info);
				Vue.set(this.table, "page", 1);
				if (info.init) {
					delete this.table.sorted.init;
					return;
				}
				this.getReports();
			},

			search(info) {
				this.table.page = 1;
				this.table.search = info;
				this.getReports();
			},

			pagination(info) {
				this.table.page = info.page;
				this.getReports();
			},
			selectReport({_id, projectId}) { 
				this.$router.push(`/reports/${projectId}/${_id}`);
			},
			async deleteReport({ _id, name, projectId }) {
				try {
					await this.$dialog.confirm(`Delete ${name}?`, {
						okText: 'Yes',
						cancelText: 'Cancel'
					});

					this.updateLoadingText('One moment...');
					await ApiService.delete(`reports/${projectId}/${_id}`);
					this.updateLoadingText();
					await this.getReports();
				} catch (err) {
					if (err) {
						console.error('Failed to delete report:', err);
						this.$snotify.error('Failed to delete report');
						this.updateLoadingText();
					}
				}
			},
		},
		computed: {
			...mapState("general", ["projectList", "projectListLoaded"]),

			allProjects() {
				if ( !this.projectListLoaded ) return { dataDive: [], rankTracking: [] }
				return { 
					dataDive: this.projectList.filter(p => p.hasDataDive === true && p.isDataDivePrimary === true).map(p => ({ value: p._id, label: new URL( p.url ).hostname, name: new URL( p.url ).hostname })), 
					rankTracking: this.projectList.filter(p => p.hasRankTracking === true).map(p => ({ value: p._id, label: p.name, name: p.name })), 
				}
			},

			hasProjects() {

				return this.allProjects.rankTracking.length > 0;// || this.allProjects.dataDive.length > 0;

			},

			sorting() {
				let sorted = this.table.sorted;

				let sortBy = Object.keys(sorted)[0],
					sortDirection = sorted[sortBy] === 1 ? "asc" : "desc";

				return { sortBy: sortBy, sortDirection: sortDirection };
			},
			queryString() {
				let queryString = [];

				Object.keys(this.table.search).forEach(
					function(k) {
						if (Array.isArray(this.table.search[k])) {
							if (this.table.search[k].length > 0) queryString.push(k + "=" + this.table.search[k].join(","));
						} else if (this.table.search[k] !== "" && this.table.search[k] !== null && this.table.search[k] !== "") {
							queryString.push(k + "=" + this.table.search[k]);
						}
					}.bind(this)
				);

				queryString.push("sortBy=" + this.sorting.sortBy + "&sortDir=" + this.sorting.sortDirection);

				queryString.push("page=" + this.table.page);

				if (queryString.length > 0) return "?" + queryString.join("&");

				return "";
			},

			emptyLabel() {
				return this.hasProjects
					? "There are no reports at the moment"
					: "You need to track some keywords or add a data dive domain first";
			},

			emptySearch() {
				return "There were no reports matching your search";
			},

			loadingText() {
				if (this.hasProjects || !this.projectListLoaded) return "Loading reports...";

				return "You need to track some keywords or add a data dive domain first";
			},

			tableHeadings() {
				return {
					nameLowercase: { value: "Name", click: "selectReport", clickVars: ["_id", "projectId"], sort: 1 },
					created: { value: "Created", dateFormat: "jS M Y", click: "selectReport", clickVars: ["_id", "projectId"], sort: -1 },
					projectName: { value: "Default Project" },
					clone: { value: "", component: TableButton, event: "cloneReport", clickVars: ["_id", "projectId"], valueForFilter: "Clone" },
					delete: { value: "", component: TableButton, event: "deleteReport", clickVars: ["_id", "projectId"], valueForFilter: "Delete" },
				};
			},
			searchSetup() {
				if ( !this.hasProjects ) return {};
				let searchSetup = {
					project: { type: "select", multi: true, showLabel: "Search by Project", items: this.allProjects.rankTracking },
					searchText: { type: "text", placeholder: "", showLabel: "Search By Name" }
				};

				return searchSetup;
			},
		},
		created() {
			this.loadProjects();
			this.getReports();
		},
	};
</script>
<style lang="less" scoped>
@import "../assets/css/less/_settings.less";
@import "../assets/css/less/_helper.less";
	.file-manager-icon {
		width: 30px;
		height: 30px;
		cursor: pointer;
	}
	.project-dropdown-wrap {
		position: absolute;
		height: 36px;
		top: 11px;
		right: 12px;
		z-index: 4;
		display: flex;
		gap: 10px;
		> div {
			flex-grow:0;
			flex-shrink:0;
		}
	}
	.project-input-description {
		font-size: 0.8em;
		color: fade(@darkContrast, 80%);
		margin-top: 5px;
		font-style: italic;
	}
	.modal-actions {
		display: flex;
		justify-content: center;
		gap: 0;
		.large-button {
			margin: 0;
		}
	}
	.modal-inner-scroll {
		form {

			margin-bottom: 30px;

		}
	}
	@media screen and (min-width: 768px) {
		.project-dropdown-wrap {
			right: 40px;
		}
		.modal-inner-scroll {
			form {
				display: flex;
				gap: 30px;
				margin-bottom: 0;
				> div {
					width: 100%;
				}
			}
		}
	}
	@media screen and (min-width: 1024px) {
		.project-dropdown-wrap {
			top: 25px;
		}
	}
</style>
